<div class="section">
  <div class="row">
    <div class="col-12">
      <p class="section__title mb-0">Review and confirm</p>
      <p class="section__subtit mb-5">
        Review the following information below to ensure it is correct. Confirm or make any necessary changes before
        proceeding.
      </p>
    </div>
  </div>
  <div class="row">
    <!-- Professional details -->
    <div class="col-4 d-flex align-items-stretch">
      <div class="summary-card">
        <div class="d-flex justify-content-between">
          <p class="title">Professional details</p>
          <xen-link
            [size]="'body'"
            [weight]="'regular'"
            [label]="'Edit details'"
            [icon]="true"
            [icon_snippet]="'fa-regular fa-pen-to-square'"
            [icon_placement]="'left'"
            [theme]="'blue'"
            [target]="'_self'"
            [underlined]="true"
            (click)="onEditSection(Steps.DETAILS)"
          ></xen-link>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Company’s traders name:</p>
              <p class="item__name">{{ companyName }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Job title:</p>
              <p class="item__name truncate-single-line">{{ jobTitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Company contacts -->
    <div class="col-4 d-flex align-items-stretch">
      <div class="summary-card">
        <div class="d-flex justify-content-between">
          <p class="title">
            {{ isBuyer && isSeller ? 'Company contacts information' : 'Buyer company contacts information' }}
          </p>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="item mb-2">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <p class="item__label">Commercial Decision Maker:</p>
                  <p class="item__name item__name--truncate">{{ apiImplementationOnboardingContact?.email }}</p>
                </div>
                <xen-link
                  [size]="'caption'"
                  [weight]="'regular'"
                  [label]="'Edit details'"
                  [icon]="true"
                  [icon_snippet]="'fa-regular fa-pen-to-square'"
                  [icon_placement]="'left'"
                  [theme]="'blue'"
                  [target]="'_self'"
                  [underlined]="true"
                  (click)="onEditContactType('Api')"
                  class="flex-shrink-0 ms-2"
                ></xen-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <p class="item__label">Technical Decision Maker:</p>
                  <p class="item__name item__name--truncate">{{ techDecisionContact?.email }}</p>
                </div>
                <xen-link
                  [size]="'caption'"
                  [weight]="'regular'"
                  [label]="'Edit details'"
                  [icon]="true"
                  [icon_snippet]="'fa-regular fa-pen-to-square'"
                  [icon_placement]="'left'"
                  [theme]="'blue'"
                  [target]="'_self'"
                  [underlined]="true"
                  (click)="onEditContactType('TechDecision')"
                  class="flex-shrink-0 ms-2"
                ></xen-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <p class="item__label">Tech Support contact:</p>
                  <p class="item__name item__name--truncate">{{ techSupportContact?.email }}</p>
                </div>
                <xen-link
                  [size]="'caption'"
                  [weight]="'regular'"
                  [label]="'Edit details'"
                  [icon]="true"
                  [icon_snippet]="'fa-regular fa-pen-to-square'"
                  [icon_placement]="'left'"
                  [theme]="'blue'"
                  [target]="'_self'"
                  [underlined]="true"
                  (click)="onEditContactType('TechSupport')"
                  class="flex-shrink-0 ms-2"
                ></xen-link>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <p class="item__label">Billing contact:</p>
                  <p class="item__name item__name--truncate">{{ billingContact?.email }}</p>
                </div>
                <xen-link
                  [size]="'caption'"
                  [weight]="'regular'"
                  [label]="'Edit details'"
                  [icon]="true"
                  [icon_snippet]="'fa-regular fa-pen-to-square'"
                  [icon_placement]="'left'"
                  [theme]="'blue'"
                  [target]="'_self'"
                  [underlined]="true"
                  (click)="onEditContactType('Billing')"
                  class="flex-shrink-0 ms-2"
                ></xen-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Billing data -->
    <div class="col-4 d-flex align-items-stretch">
      <div class="summary-card">
        <div class="d-flex justify-content-between">
          <p class="title">Billing data</p>
          <xen-link
            [size]="'body'"
            [weight]="'regular'"
            [label]="'Edit details'"
            [icon]="true"
            [icon_snippet]="'fa-regular fa-pen-to-square'"
            [icon_placement]="'left'"
            [theme]="'blue'"
            [target]="'_self'"
            [underlined]="true"
            (click)="onEditSection(Steps.BILLING)"
          ></xen-link>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Fiscal company name:</p>
              <p class="item__name">{{ billingAccount?.name }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Street Address (business):</p>
              <p class="item__name">{{ billingAccount?.fiscalAddress }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">City:</p>
              <p class="item__name">{{ billingAccount?.city }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Country:</p>
              <p class="item__name">{{ countryString }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">Zip Code:</p>
              <p class="item__name">{{ billingAccount?.zipCode }}</p>
            </div>
          </div>
          <div class="col-12">
            <div class="item mb-2">
              <p class="item__label">VAT / ID Number:</p>
              <p class="item__name">{{ billingAccount?.cif }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm and finish -->
  <div class="row mb-5">
    <div class="col-12">
      <xen-btn
        class="d-block mt-4 d-flex justify-content-end"
        [type]="'primary'"
        [size]="'large'"
        [label]="'Confirm and finish'"
        [icon]="true"
        [icon_placement]="'right'"
        [icon_snippet]="'far fa-angle-right'"
        [skin]="'blue'"
        [loading]="loadingButton"
        [disabled]="loadingButton"
        (clicked)="submitReview()"
      ></xen-btn>
    </div>
  </div>
</div>
